// removed by extract-text-webpack-plugin
module.exports = {"date":"_1rBi29pGwGdvHsL8C0jpEn","intro":"_2CuViCaoEifP5CZDRJVCp7","photos":"eYhSJ8SNlnqfvICvmMvOm","person":"_3veGBSI346Uiyi1CggDgwk"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/TrainingGroup/TrainingGroup.scss
// module id = 883
// module chunks = 0